import React, { FC } from 'react';

import SanityBlockRenderer, {
  IBlockContentOverrides,
  ISerializers,
  PassthroughComponent,
} from 'components/sanity-block-renderer';

import { HeaderEm, HeaderH2, HeaderH3, HeaderP, HeaderStrong } from './header-block.styled';
import { ISanityBlockRenderer } from './types';

const pointBlockContentOverrides: IBlockContentOverrides = {
  normal: HeaderP,
  h2: HeaderH2,
  h3: HeaderH3,
};

const pointBlockSerializers: ISerializers = {
  marks: {
    strong: HeaderStrong,
    em: HeaderEm,
  },
  container: PassthroughComponent,
};

export const HeaderBlock: FC<ISanityBlockRenderer> = ({ content }) => (
  <SanityBlockRenderer
    blockContentOverrides={pointBlockContentOverrides}
    serializers={pointBlockSerializers}
    content={content}
  />
);
